import { render } from "./UserContentWrapper.vue?vue&type=template&id=4f5a8d2e"
import script from "./UserContentWrapper.vue?vue&type=script&lang=js"
export * from "./UserContentWrapper.vue?vue&type=script&lang=js"

import "./UserContentWrapper.vue?vue&type=style&index=0&id=4f5a8d2e&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__